<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
	import './assets/css/common.css';
  // import './assets/scss/element-variables.scss';
  // import './assets/scss/default.scss';
  // import './assets/scss/cover.scss';
export default {
  name: 'App',
  provide(){
    return{
      reload: this.reload,
    }
  },
  data(){
    return{
      isRouterAlive: true,
    }
  },
  methods: {
    reload: function () {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      })
    }
  }
}
</script>

<style>
#app{
	background: #F5F6F8;
}
.van-button--info{
	background-color: #4E77FF;
	border: 1px solid #4E77FF;
}
.van-stepper{
	flex-shrink: 0;
}
.van-stepper__minus, .van-stepper__plus{
	/* background-color: #4F77FF; */
}
.van-stepper__minus::before, .van-stepper__plus::before{
	width: 30%;
	/* color: #fff; */
}
.van-stepper__minus::after, .van-stepper__plus::after {
    height: 30%;
	/* color: #fff; */
}
.van-stepper__input{
	margin: 0;
	background-color:#fff;
	border-top: 1px solid #f2f3f5;
	border-bottom: 1px solid #f2f3f5;
}
.van-slider__bar{
	background-color:#4E77FF
}
.van-sidebar{
	width: auto!important;
	margin-top: 0.3rem;
}
.van-sidebar-item--select::before{
	background-color: #4E77FF;
}
.van-tabs__nav{
	white-space: nowrap;
}
.special .van-field__control{
	font-size: 0.36rem;
	color: #FF1515;
	font-weight: 600;
}

.van-tabs__wrap{
	flex-shrink: 0;
}
.van-tabs__content{
	overflow-y: auto;
	overflow-x: hidden;
}
#order-detail .van-uploader__upload{
	height: 0.44rem!important;;
	width: 0.44rem!important;
}
#order-detail .con_info li .text_box .text_info p{
	margin: 0;
	word-break: break-all;
}
.polishing-box .van-field__control{
	border: 1px solid #ddd!important;
	padding: 0 0.1rem;
}

   .message-content p img{
	   max-width: 100%!important;
   }
   .van-nav-bar .van-icon,.van-nav-bar__text {
       color: #333;
   }
   
   .van-cell{
   	border-bottom: 1px solid #f7f7f7;
   	padding: 0 0.3rem 0 0.4rem;
   	line-height: 1rem;
	min-height: 1rem;
   }
   .van-cell:last-child{
	   border-bottom: 0 none;
   }
   .bottom_bar .van-cell{
	   padding: 0;
   }
   .van-cell::after{
   	border-bottom: 0 none
   }
   .van-cell__left-icon, .van-cell__right-icon,.van-field__control--custom {
       min-height: 1rem;
       line-height: 1rem;
   }
   .van-field__label{
	   color: #333;
	   /* font-size: 0.28rem; */
   }
   .van-button--small {
       height: 32px;
       padding: 0 8px;
   }
  /* .van-field__body{
	   height: 100%;
   } */
   .van-tabs--line .van-tabs__wrap {
       height: 1rem;
   }
   .van-tabs--card>.van-tabs__wrap,.van-tabs__nav--card{
	   height: 0.7rem;
   }
   .van-nav-bar__arrow {
       font-size: 20px;
   }
   .van-nav-bar__left, .van-nav-bar__right{
	   padding: 0 0.2rem;
   }
   .van-field__error-message{
		line-height: 0.5rem;
   }
   .van-field--error .van-field__control{
	   color: #323233!important;
   }
   .van-field--error .van-field__control::placeholder{
	   color: #BCBCBC!important;
   }
   textarea.van-field__control{
	   line-height: 0.5rem;
	   padding: 0.25rem 0;
   }
   .van-radio__icon--checked .van-icon,.van-checkbox__icon--checked .van-icon{
	   background-color: #4E77FF;
	   border-color: #4E77FF;
   }
   .oper_dialog .van-button--normal{
   	width: 100%;
   	display: block;
   	border-top: 0 none;
   	font-size: 0.32rem!important;
   	height: 1.2rem;
   }
   	.van-loading__spinner{
   		display: block!important;
   	}
	.el-checkbox{
		display: flex;
		align-items: flex-start!important;
	}
	.el-checkbox__label{
		white-space: initial;
		margin-left: -0.1rem;
		font-size:0.26rem
	}
	
	#activity .el-input__inner{
		border: 0 none!important;
	}
	#activity .el-input--suffix .el-input__inner{
		text-align: right;
		color: #333;
		font-size: 0.28rem;
		font-weight: 600;
		padding-left: 0;
	}
	#activity .imageType .el-input--suffix .el-input__inner{
		text-align: left;
		width: 105px;
	}
	.popper__arrow{
		display: none!important;
	}
	.el-select-dropdown__item{
		text-align: right!important;
	}
	.el-scrollbar .el-scrollbar__bar {
	    opacity: 1 !important;
	}
#Register .van-checkbox__label{
	margin-top: -0.05rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue